<div class="card-header text-center">
  <div class="row">
    <div class="col-md-8">
      <p class="h3">Administrar Pedidos</p>
    </div>
    <div class="col-md-4">
      <h5 class="text-right">
        <a class="btn btn-info text-white" [routerLink]="['/dashboard/order']">
          Registrar[+]
        </a>
      </h5>
    </div>
  </div>
</div>
<ngb-tabset>
  <ngb-tab title="PEDIDOS">
    <ng-template ngbTabContent>
      <app-ordenes></app-ordenes>
    </ng-template>
  </ngb-tab>
  <ngb-tab title="DESPACHADOS">
    <ng-template ngbTabContent>
      <app-despachados></app-despachados>
    </ng-template>
  </ngb-tab>
  <ngb-tab title="CONCLUIDOS">
    <ng-template ngbTabContent>
      <app-concluidos></app-concluidos>
    </ng-template>
  </ngb-tab>
  <ngb-tab title="ANULADOS">
    <ng-template ngbTabContent>
      <app-anulados></app-anulados>
    </ng-template>
  </ngb-tab>

  
</ngb-tabset>
